export default __webpack_public_path__ + "static/media/banner.8aad1c38.png";